"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.capitalize = capitalize;

var _preposicoes = require("./preposicoes.json");

var _preposicoes2 = _interopRequireDefault(_preposicoes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function capitalize(string) {
    string = string.toLocaleLowerCase();

    string = string.replace(/(^| )(\w)/g, function (x) {
        return x.toUpperCase();
    });

    _preposicoes2.default.forEach(function (p) {
        string = string.replace(new RegExp(p.uppercase, 'g'), p.lowcase);
    });

    return string;
}


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/helpers/FormHelper.js
// module id = 601
// module chunks = 0